import * as angular from "angular";

let PageHeadingComponent = {
    selector: "vcPageHeading",
    templateUrl: "/angular/components/page-heading/page-heading.component.html",
    bindings: {
        title: "=?",
        description: "=?",
        imageUrl: "=?",
        supportUrl: "=?",
        helpButtonClass: "=?",
        imgWidth: "=?",
        inCard: "=?",
        fill: "=?",
    },
    controller: class PageHeadingController {
        // * bindings for typescript compiler *
        public title?: any;
        public description?: any;
        public imageUrl?: any;
        public supportUrl?: any;
        public helpButtonClass?: any;
        public imgWidth?: any;
        public fill?: any;
        public inCard?: boolean;
        // ************************************

        $onInit() {
            if (!this.imgWidth) {
                this.imgWidth = 144;
            }
            if (angular.isUndefined(this.inCard)) {
                this.inCard = true;
            }
        }
    },
};

angular
    .module("pageHeading", [])
    .component(PageHeadingComponent.selector, PageHeadingComponent);
